import { FaSpinner } from "react-icons/fa";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  setCategoryType,
  setLocation,
  setSelectedAudience,
  setSelectedCommunity,
  uploadPostByUser,
} from "../../redux/posts/posts.action";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  getStorage,
} from "firebase/storage";
import Modal from "../Modal/Modal";
import { HiMapPin } from "react-icons/hi2";
import GlobeIcon from "../../assets/images/globe.svg";
import Iconly from "../../assets/images/Image.svg";
import Location from "../../assets/images/location.svg";
import Video from "../../assets/images/video-recorder.svg";
import Smile from "../../assets/images/smile.svg";
import { useDisclosure } from "@chakra-ui/react";
import SelectLocation from "./SelectLocationModal";
import SelectCategory from "./SelectCategory";
import PostAudience from "./Audience";
import { RiAlarmWarningLine } from "react-icons/ri";
import SelectUser from "./SelectUser";
import { FaRegTrashCan } from "react-icons/fa6";
import Loader from "../Loader";
import SharePost from "./SharePost";
import SelectComm from "./SelectComm";
import { PiUsersThree } from "react-icons/pi";
import { getGoogleLocation } from "../../utils/utils";

function UploadEmergency({
  updateModal,
  commuinityID,
  refreshCommunity,
  postTo,
}) {
  const location = useLocation();

  const [loading] = useState(false);
  const [value, setValue] = useState({
    text: "",
    title: "",
  });
  const uploadModalStatus = useSelector((state) => state.auth.showUploadModal);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [currentLocation, setCurrentLocation] = useState({
    longitude: 0,
    latitude: 0,
  });
  const dispatch = useDispatch();
  const routePath = useLocation();
  const token = useSelector((state) => state.auth.accessToken);
  const {
    uploadData,
    activeCategory,
    activeLocation,
    selectedCommunity,
    selectedAudience,
    uploadLoading,
  } = useSelector((state) => state.posts);
  const darktheme = useSelector((state) => state.features.settings.darktheme);

  const inputRef = useRef(null);
  const textRef = useRef(null);
  const titleRef = useRef(null);
  const [imageArray, setImageArray] = useState([]);
  const [imageUrl, setImageUrl] = useState([]);
  const [percent, setPercent] = useState(0);
  const [videoArray, setVideoArray] = useState([]);
  const [videoUrl, setVideoUrl] = useState([]);
  const [progress, setProgress] = useState(0);
  const [dataUploading, setDataUploading] = useState(false);
  const onTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    onTop();
  }, [routePath]);

  const next = (item) => {
    onOpen();
    updateModal(item);
  };

  const onHandleChange = (e) => {
    e.preventDefault();
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);

    if (!files.length) return;

    const newVideos = [];
    const newImages = [];

    files.forEach(file => {
      if (file.type.includes("video")) {
        newVideos.push(file);
      } else if (file.type.includes("image")) {
        newImages.push(file);
      }
    });

    if (newVideos.length) {
      setVideoArray([...videoArray, ...newVideos]);
    }

    if (newImages.length) {
      setImageArray([...imageArray, ...newImages]);
    }
  };

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const { lat, lng } = await getGoogleLocation();
        setCurrentLocation({
          latitude: lat,
          longitude: lng,
        });
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    fetchLocation();
    // eslint-disable-next-line
  }, []);

  const closeModal = () => {
    if (location.pathname.includes("/dashboard/community/view")) {
      refreshCommunity();
    }
    dispatch(setCategoryType({}));
    dispatch(setLocation(null));
    onClose();
    updateModal(false);
    dispatch(setCategoryType({}));
    dispatch(setSelectedCommunity({}));
    dispatch(setSelectedAudience(""));
  };

  const handleUploadImage = (e) => {
    e.preventDefault();
    inputRef.current.click();
  };

  const uploadImages = async (files) => {
    return new Promise((resolve, reject) => {
      if (files.length === 0) {
        resolve([]);
        return;
      }

      const storage = getStorage();
      const uploadPromises = files.map((file) => {
        return new Promise((innerResolve, innerReject) => {
          const storageRef = ref(storage, `images/${file.name}`);
          const uploadTask = uploadBytesResumable(storageRef, file);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const percent = Math.round(
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              );
              setProgress((prev) => ({ ...prev, [file.name]: percent }));
            },
            (error) => innerReject(error),
            async () => {
              try {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                innerResolve(downloadURL);
              } catch (error) {
                innerReject(error);
              }
            }
          );
        });
      });

      Promise.all(uploadPromises)
        .then((downloadURLs) => {
          setImageUrl(downloadURLs);
          resolve(downloadURLs);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const uploadVideos = async (files) => {
    return new Promise((resolve, reject) => {
      if (files.length === 0) {
        resolve([]);
        return;
      }

      const storage = getStorage();
      const uploadPromises = files.map((file) => {
        return new Promise((innerResolve, innerReject) => {
          const storageRef = ref(storage, `videos/${file.name}`);
          const uploadTask = uploadBytesResumable(storageRef, file);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const percent = Math.round(
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              );
              setPercent(percent);
            },
            (error) => innerReject(error),
            async () => {
              try {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                innerResolve(downloadURL);
              } catch (error) {
                innerReject(error);
              }
            }
          );
        });
      });

      Promise.all(uploadPromises)
        .then((downloadURLs) => {
          setVideoUrl(downloadURLs);
          resolve(downloadURLs);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const createPost = async (imageUrls, videoUrls) => {
    const payload = {
      coords:
        currentLocation.latitude !== null
          ? {
            latitude: currentLocation.latitude,
            longitude: currentLocation.longitude,
          }
          : {
            latitude: 0,
            longitude: 0,
          },
      title: value.title,
      platform: "web",
      text: value.text,
      category: activeCategory,
      media: {
        images: imageUrls,
        videos: videoUrls,
      },
      mapUrl: "",
      label: "",
      icons: "",
      userIds: [],
      communityID: location.pathname.includes("/dashboard/community/view")
        ? commuinityID
        : selectedCommunity?.id,
    };


    await dispatch(uploadPostByUser(payload));

    setDataUploading(false);
    closeModal();
    next(66);
  };

  const handleUploadData = async () => {
    setDataUploading(true);
    try {
      let uploadedImageUrls = [];
      if (imageArray.length > 0) {
        uploadedImageUrls = await uploadImages(imageArray);
      }

      let uploadedVideoUrls = [];
      if (videoArray.length > 0) {
        uploadedVideoUrls = await uploadVideos(videoArray);
      }

      await createPost(uploadedImageUrls, uploadedVideoUrls);
    } catch (error) {
      console.error("Error uploading media:", error);
      setDataUploading(false);
    }
  };

  const handleSubmit = () => {
    if (!value.text || !value.title || !activeLocation || !activeCategory) {
      alert("Please fill all required fields");
      return;
    }

    handleUploadData();
  };

  const deleteImage = (indexToDelete) => {
    setImageArray((imageArray) => {
      return imageArray.filter((item, index) => index !== indexToDelete);
    });
  };

  const deleteVideo = (indexToDelete) => {
    setVideoArray((videoArray) => {
      return videoArray.filter((item, index) => index !== indexToDelete);
    });
  };

  const handleFocus = (event) => {
    if (event.key === "Enter") {
      textRef.current.focus();
    }
  };

  return (
    <>
      {uploadModalStatus === 60 && (
        <Modal
          isCentered
          isOpen={uploadModalStatus === 60}
          onClose={closeModal}
          title="Upload Incident"
          className={`rounded-[60px]  ${darktheme ? "bg-kdark3" : "bg-white"
            }`}
        >
          {uploadLoading ? (
            <div className="text-center mx-auto">
              <Loader big={true} />
            </div>
          ) : (
            <div className="w-full h-auto flex flex-col gap-8 relative">
              <input
                name="title"
                placeholder="What's happening..."
                className={`w-full text-[20px] ${darktheme ? "text-[#F7F7F7]" : "text-[#718096]"}  bg-transparent outline-none`}
                value={value.title}
                onChange={(e) => onHandleChange(e)}
                onKeyDown={handleFocus}
                ref={titleRef}
              />
              <textarea
                className={`w-full h-[70px] text-[14px] bg-transparent ${darktheme ? "text-[#F7F7F7]" : "text-[#718096]"} outline-none`}
                placeholder="Provide more description about what's happening..."
                value={value.text}
                name="text"
                ref={textRef}
                onChange={(e) => onHandleChange(e)}
              ></textarea>
              <div className="flex flex-wrap cursor-pointer items-center gap-2 font-[400]">
                <button
                  onClick={() => next(61)}
                  className={`flex gap-[4px]  truncate  py-[6px]  font-[400] text-[14px]  h-[32px] pr-[16px] pl-[6px]  ${darktheme ? "bg-[#ffff3B0D] text-[#EAECF0]" : "bg-[#00003B0D] text-[#586f94]"
                    } rounded-[999px] items-center  cursor-pointer`}
                >
                  <HiMapPin className="text-[#425466]" />{" "}
                  {activeLocation ? activeLocation?.slice(0, 8) : "Location"}
                </button>
                <button
                  onClick={() => next(62)}
                  className={`flex gap-[4px] font-[400] text-[14px] py-[6px] h-[32px]  pr-[16px] pl-[6px] cursor-pointer rounded-[999px] items-center ${darktheme ? "text-[#EAECF0]" : "text-[#586f94]"
                    }`}
                  style={{
                    background: activeCategory?.labelBgColor
                      ? activeCategory?.labelBgColor
                      : `${darktheme ? "bg-[#ffff3B0D] text-[#EAECF0]" : "bg-[#00003B0D] text-[#586f94]"
                      }`,
                  }}
                //
                >
                  <RiAlarmWarningLine
                    className="text-[#425466]  "
                    style={{
                      background: activeCategory?.labelBgColor,
                      color: activeCategory?.iconColor,
                    }}
                  />{" "}
                  {activeCategory?.title
                    ? activeCategory?.title?.slice(0, 10)
                    : "Incident type"}
                </button>
                {location.pathname.includes("/dashboard/community/view/") ? (
                  <button
                    onClick={() => next(63)}
                    className="flex gap-[4px] py-[6px] font-[400] text-[14px]  h-[32px] pr-[16px] pl-[6px] bg-[#D2F4FD] rounded-[999px] items-center text-[#1c2024] cursor-pointer"
                  >
                    <PiUsersThree className="text-[#425466]" /> {postTo}
                  </button>
                ) : (
                  <button
                    onClick={() => next(63)}
                    className={`flex gap-[4px] py-[6px] font-[400] text-[14px]  h-[32px] pr-[16px] pl-[6px] rounded-[999px] items-center ${darktheme ? "bg-[#ffff3B0D] text-[#EAECF0]" : "bg-[#00003B0D] text-[#586f94]"} cursor-pointer`}
                  >
                    <img
                      src={GlobeIcon}
                      alt="icon"
                      className={`${darktheme ? "text-[#EAECF0]" : "text-[#586f94]"}`}
                    />
                    {selectedAudience}
                  </button>
                )}
              </div>
              {
                imageArray.length === 0 && videoArray.length === 0 ? "" :
                  <div className="flex flex-wrap overflow-x-scroll w-full">
                    {imageArray.length > 0 &&
                      imageArray?.map((item, i) => (
                        <div
                          key={i}
                          className=" mr-[.5rem] w-[31%] h-[120px] rounded-[10px]"
                        >
                          {item && (
                            <div
                              className="relative rounded-[10px] h-full "
                              onClick={() => deleteImage(i)}
                            >
                              <FaRegTrashCan className="text-[red] cursor-pointer  absolute  w-30 z-30 right-2 top-1 h-3" />
                              <img
                                src={URL.createObjectURL(item)}
                                alt="uploaded post files"
                                className="object-cover rounded-[10px] w-full h-full absolute"
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    {videoArray.length > 0 &&
                      videoArray.map((item, i) => (
                        <div
                          key={i}
                          className="bg-black mr-[.5rem] w-[60px] h-[60px] rounded-[10px]"
                        >
                          {item && (
                            <div
                              className="relative h-full w-full "
                              onClick={() => deleteVideo(i)}
                            >
                              <FaRegTrashCan className="text-[white] absolute  w-30 z-30 right-1 top-1 h-3" />
                              <video
                                controls={false}
                                className="w-full h-full object-cover absolute"
                              >
                                <source src={URL.createObjectURL(item)} type={item.type} />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
              }
              <div className=" w-full">
                <div className="flex items-center justify-between w-full">
                  <div className="flex gap-4">
                    <img src={Smile} alt="icon" />
                    <input
                      type="file"
                      className="hidden"
                      onChange={handleFileChange}
                      accept="image/*, video/*  mp4/* "
                      multiple
                      ref={inputRef}
                    />
                    <img
                      src={Video}
                      alt="icon"
                      onClick={(e) => handleUploadImage(e)}
                    />
                    <img
                      src={Iconly}
                      alt="icon"
                      onClick={(e) => handleUploadImage(e)}
                    />
                    <img src={Location} alt="icon" onClick={() => next(61)} />
                  </div>
                  <div>
                    <button
                      onClick={handleSubmit}
                      disabled={
                        value?.text?.length === 0 ||
                          value.title?.length === 0 ||
                          activeLocation?.length === 0 ||
                          activeCategory?.length === 0
                          ? true
                          : false
                      }
                      className={`${value?.text?.length === 0 ||
                        value.title?.length === 0 ||
                        activeLocation?.length === 0 ||
                        activeCategory?.length === 0
                        ? "bg-[#b7b6b6]"
                        : "bg-[#E5484D]"
                        } rounded-[12px] px-6 py-2  cursor-pointer font-medium text-base text-white`}
                    >
                      {dataUploading ? "Posting..." : "Post"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      )}
      {uploadModalStatus === 61 && (
        <Modal
          isOpen={uploadModalStatus === 61 && isOpen}
          onClose={() => next(60)}
          previous={60}
          title="Select Location"
          className="rounded-2xl"
        >
          {loading ? (
            <FaSpinner className="text-center mx-auto" />
          ) : (
            <SelectLocation
              theme={darktheme}
              setCurrentLocation={setCurrentLocation}
              next={next}
            />
          )}
        </Modal>
      )}
      {uploadModalStatus === 62 && (
        <Modal
          isOpen={uploadModalStatus === 62 && isOpen}
          onClose={() => next(60)}
          previous={61}
          title="Incident Category"
          className="rounded-2xl"
        >
          {loading ? (
            <FaSpinner className="text-center mx-auto" />
          ) : (
            <SelectCategory token={token} next={next} />
          )}
        </Modal>
      )}
      {uploadModalStatus === 63 && (
        <Modal
          isOpen={uploadModalStatus === 63 && isOpen}
          onClose={() => next(60)}
          previous={60}
          title="Post Audience"
          className="rounded-2xl"
        >
          {loading ? (
            <FaSpinner className="text-center mx-auto" />
          ) : (
            <PostAudience token={token} active={selectedAudience} next={next} />
          )}
        </Modal>
      )}
      {uploadModalStatus === 64 && (
        <Modal
          isOpen={uploadModalStatus === 64 && isOpen}
          onClose={() => next(60)}
          previous={63}
          title="Select Community"
          className="rounded-2xl"
        >
          {loading ? (
            <FaSpinner className="text-center mx-auto" />
          ) : (
            <SelectComm next={next} />
          )}
        </Modal>
      )}
      {uploadModalStatus === 65 && (
        <Modal
          isOpen={uploadModalStatus === 65 && isOpen}
          onClose={() => next(60)}
          previous={63}
          title="Select User"
          className="rounded-2xl"
        >
          {loading ? (
            <FaSpinner className="text-center mx-auto" />
          ) : (
            <SelectUser next={next} />
          )}
        </Modal>
      )}
      {uploadModalStatus === 66 && (
        <Modal
          isOpen={uploadModalStatus === 66 && isOpen}
          onClose={closeModal}
          title="Post Uploaded Successfully"
          className="rounded-2xl"
          size={"sm"}
        >
          <SharePost
            theme={darktheme}
            next={next}
            id={uploadData?.id}
            header="Post Uploaded Successfully"
            title={uploadData?.title}
          />
        </Modal>
      )}
    </>
  );
}

export default UploadEmergency;